import { useCallback, useRef, useState } from 'react';

/**
 * 文本溢出检测：返回 [ref, overflow, check]。把 ref 挂到目标元素，
 * mouseEnter / 内容变化时手动调 check() 取最新结果，避免常驻 ResizeObserver。
 * mode='width' 单行截断（scrollWidth > clientWidth），'height' 多行截断（scrollHeight > clientHeight）。
 */
export function useTextOverflow<T extends HTMLElement = HTMLDivElement>(
  mode: 'width' | 'height' = 'width',
): [React.RefObject<T | null>, boolean, () => void] {
  const ref = useRef<T>(null);
  const [overflow, setOverflow] = useState(false);
  const check = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    if (mode === 'height') {
      setOverflow(el.scrollHeight > el.clientHeight);
    } else {
      setOverflow(el.scrollWidth > el.clientWidth);
    }
  }, [mode]);
  return [ref, overflow, check];
}
